var map = {
	"./": 19522,
	"./en_US": 85116,
	"./en_US.js": 85116,
	"./index": 19522,
	"./index.js": 19522,
	"./ko_KR": 43346,
	"./ko_KR.js": 43346,
	"./kz_KZ": 57374,
	"./kz_KZ.js": 57374,
	"./mn_MN": 1166,
	"./mn_MN.js": 1166,
	"./ru_RU": 83689,
	"./ru_RU.js": 83689
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 14203;
module.exports = webpackAsyncContext;